import ClickEventTargetManager from '../ClickEventTargetManager';
import TrackSearchResults from './TrackSearchResults';

export default class SearchClickEventTargetManager extends ClickEventTargetManager {
    protected override handleEvent(event: Event, element: HTMLElement): void {
        TrackSearchResults.trackSelectItem(element as HTMLAnchorElement);
        super.handleEvent(event, element);
    }
}
